import React from 'react';
import s from './LineItems.scss';
import { Text } from '@wix/design-system';
import { currencyFormat } from '../../../core';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { HeaderLine } from './HeaderLine';
import { BodyCell } from './BodyCell';
import { GridTable } from './GridTable';
const LineItems = ({ t, lineItems, locale, currencyCode, showTaxColumn = false, tableStyle, }) => {
    const currency = currencyFormat({ locale, currency: currencyCode });
    const customHeader = s.customizeHeader;
    const customCell = s.customizeCell;
    const customizePriceTitle = s.customizePriceTitle;
    const customQuantityTitle = s.customizeQuantityTitle;
    const customTotalTitle = s.customizeTotalTitle;
    const customPriceCell = s.customizePriceCell;
    if (tableStyle === 'grid') {
        return (React.createElement(GridTable, { formatCurrency: currency, lineItems: lineItems, showTaxColumn: showTaxColumn }));
    }
    return (React.createElement("table", { className: s.table },
        React.createElement("thead", { className: s.head },
            React.createElement("tr", null,
                React.createElement("th", { className: `${s.header} ${customHeader}` },
                    React.createElement(HeaderLine, { dataHook: "product-title" }, t('invoice-view:price-quote.view.line-items.product'))),
                React.createElement("th", { className: `${s.header} ${customHeader} ${customizePriceTitle}` },
                    React.createElement(HeaderLine, { dataHook: "price-title" }, t('invoice-view:price-quote.view.line-items.price'))),
                React.createElement("th", { className: `${s.header} ${customHeader} ${customQuantityTitle}` },
                    React.createElement(HeaderLine, { dataHook: "quantity-title" }, t('invoice-view:price-quote.view.line-items.quantity'))),
                showTaxColumn ? (React.createElement("th", { className: `${s.header} ${customHeader} ${s.customizeTaxTitle}` },
                    React.createElement(HeaderLine, { dataHook: "tax-title" }, t('invoice-view:price-quote.view.line-items.tax')))) : null,
                React.createElement("th", { className: `${s.header} ${customHeader} ${s.pullRight} ${customTotalTitle}` },
                    React.createElement(HeaderLine, { dataHook: "total-title" }, t('invoice-view:price-quote.view.line-items.total'))))),
        React.createElement("tbody", null, lineItems.map(({ name, description, price, quantity, total, taxes }, index) => [
            React.createElement("tr", { key: index },
                React.createElement("td", { className: `${s.cell} ${customCell}` },
                    React.createElement("div", { className: s.productName },
                        React.createElement(BodyCell, { dataHook: `name-${index}` }, name)),
                    React.createElement("div", { className: s.description },
                        React.createElement("span", { className: s.spanForThaiPdf, "data-hook": `description-${index}` }, description))),
                React.createElement("td", { className: `${s.cell} ${customCell} ${customPriceCell}` },
                    React.createElement(BodyCell, { dataHook: `price-${index}` }, currency(price))),
                React.createElement("td", { className: `${s.cell} ${customCell}` },
                    React.createElement(BodyCell, { dataHook: `quantity-${index}` }, quantity)),
                showTaxColumn ? (React.createElement("td", { className: `${s.cell} ${customCell} ${customizePriceTitle}` }, taxes.map((tax, taxIndex) => {
                    return (React.createElement("div", { style: { display: 'block' }, key: taxIndex },
                        React.createElement(BodyCell, { dataHook: `tax-${index}-${taxIndex}` }, t('invoice-view:price-quote.view.totals.tax-rate', {
                            name: tax.name,
                            rate: tax.rate?.serializedValue ?? 0,
                        }))));
                }))) : null,
                React.createElement("td", { className: `${s.cell} ${customCell} ${s.pullRight}` },
                    React.createElement(BodyCell, { dataHook: `total-${index}` }, currency(total)))),
            React.createElement("tr", { className: s.descriptionRow, key: `${index}A` },
                React.createElement("td", { colSpan: 4 },
                    React.createElement("div", { className: s.descriptionCells },
                        React.createElement(Text, { dataHook: `description-row-${index}`, secondary: true, light: true, size: "small" }, description)))),
            React.createElement("tr", { key: `${index}B` },
                React.createElement("td", { colSpan: 12 },
                    React.createElement("hr", { className: s.divider }))),
        ]))));
};
export default withTranslation()(LineItems);
//# sourceMappingURL=LineItems.js.map